import classNames from 'classnames';
import { array, object, string } from 'prop-types';
import React from 'react';
import LinkButton from '../Buttons/LinkButton';
import SemanticHeader from '../Chapter/semantic-header';
import Badge from '../IDSBadge';
import RegionalHighlightTextBlock from '../TextBlock/RegionalHighlightTextBlock';

const HighLight = (props) => {
  const {
    SelectedType,
    SelectedIcon,
    SelectedBackgroundColor,
    Buttons,
    Heading,
    ContentString,
    isMemberOfChapterContainer,
    isH3,
    RegionalContent,
    isInRegionalContainer,
  } = props;
  const classes = classNames({
    'c-highlight': true,
    [`c-highlight--${SelectedType}`]: SelectedType,
    [`c-highlight--${SelectedIcon}`]: SelectedIcon,
    [`c-highlight--${SelectedBackgroundColor}`]: SelectedBackgroundColor,
    [`c-highlight--regional-badge-top`]: isInRegionalContainer,
  });

  const dataPrintSidebarTitle =
    Heading ||
    props.CurrentPageProps?.Content?.Translations?.highlightblock ||
    '';

  return (
    <aside
      className={classes}
      id={props.AnchorSectionId}
      data-print-sidebar-title={dataPrintSidebarTitle}
      data-is-member-of-chapter-container={
        isMemberOfChapterContainer || 'false'
      }
    >
      {isInRegionalContainer && (
        <div className="c-highlight__badge-container">
          <Badge
            type={'secondary'}
            text={`${props.CurrentPageProps?.Content?.Translations?.regionlabel} ${props?.RegionNames}`}
          />
        </div>
      )}

      {Heading && (
        <SemanticHeader
          className="c-highlight__header"
          isH3={isH3 && isMemberOfChapterContainer}
        >
          {Heading}
        </SemanticHeader>
      )}
      <div className="c-highlight__text-container">{ContentString}</div>

      {RegionalContent && (
        <RegionalHighlightTextBlock
          regionalContent={RegionalContent}
          translation={
            props.CurrentPageProps?.Content?.Translations?.regionlabel
          }
        />
      )}

      {Buttons && Buttons[0] && (
        <div className="c-highlight__cta-container">
          <LinkButton
            link={Buttons[0].ButtonLink}
            linkText={Buttons[0].ButtonText}
            buttonClass={`c-highlight__cta-container__${Buttons[0].ButtonStyling}`}
          />
          {Buttons[1] && (
            <LinkButton
              link={Buttons[1].ButtonLink}
              linkText={Buttons[1].ButtonText}
              buttonClass={`c-highlight__cta-container__${Buttons[1].ButtonStyling}`}
            />
          )}
        </div>
      )}
    </aside>
  );
};

HighLight.propTypes = {
  SelectedType: string,
  SelectedIcon: string,
  SelectedBackgroundColor: string,
  Buttons: array,
  Heading: string,
  ContentString: object,
};

export default HighLight;
